exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#events tr{cursor:pointer}#events .row-link{color:inherit;text-decoration:none}.filter-panel{overflow:hidden;max-height:0;transition:max-height .35s ease}.filter-panel-open{max-height:1000px}.filter-panel-content{border:1px solid #dee2e6;border-radius:0 .25rem .25rem .25rem;padding:.75rem 1rem .5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c197dbc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Events.vue
// module id = 873
// module chunks = 0